import { TranslationKeys } from '../../TranlsationKeys';

const countryDescriptions: Record<string, { title: TranslationKeys; text: TranslationKeys[] }> = {
  ES: {
    title: 'ClubListContainer.Description.Country.Spanien.Title',
    text: [
      'ClubListContainer.Description.Country.Spanien.p1',
      'ClubListContainer.Description.Country.Spanien.p2',
      'ClubListContainer.Description.Country.Spanien.p3',
      'ClubListContainer.Description.Country.Spanien.p4',
      'ClubListContainer.Description.Country.Spanien.p5',
      'ClubListContainer.Description.Country.Spanien.p6',
      'ClubListContainer.Description.Country.Spanien.p7',
    ],
  },
  FR: {
    title: 'ClubListContainer.Description.Country.Frankrike.Title',
    text: [
      'ClubListContainer.Description.Country.Frankrike.p1',
      'ClubListContainer.Description.Country.Frankrike.p2',
      'ClubListContainer.Description.Country.Frankrike.p3',
      'ClubListContainer.Description.Country.Frankrike.p4',
      'ClubListContainer.Description.Country.Frankrike.p5',
      'ClubListContainer.Description.Country.Frankrike.p6',
    ],
  },
  CZ: {
    title: 'ClubListContainer.Description.Country.Tjeckien.Title',
    text: [
      'ClubListContainer.Description.Country.Tjeckien.p1',
      'ClubListContainer.Description.Country.Tjeckien.p2',
      'ClubListContainer.Description.Country.Tjeckien.p3',
      'ClubListContainer.Description.Country.Tjeckien.p4',
      'ClubListContainer.Description.Country.Tjeckien.p5',
      'ClubListContainer.Description.Country.Tjeckien.p6',
    ],
  },
  SK: {
    title: 'ClubListContainer.Description.Country.Slovakien.Title',
    text: [
      'ClubListContainer.Description.Country.Slovakien.p1',
      'ClubListContainer.Description.Country.Slovakien.p2',
      'ClubListContainer.Description.Country.Slovakien.p3',
      'ClubListContainer.Description.Country.Slovakien.p4',
      'ClubListContainer.Description.Country.Slovakien.p5',
      'ClubListContainer.Description.Country.Slovakien.p6',
    ],
  },
  PT: {
    title: 'ClubListContainer.Description.Country.Portugal.Title',
    text: [
      'ClubListContainer.Description.Country.Portugal.p1',
      'ClubListContainer.Description.Country.Portugal.p2',
      'ClubListContainer.Description.Country.Portugal.p3',
      'ClubListContainer.Description.Country.Portugal.p4',
      'ClubListContainer.Description.Country.Portugal.p5',
      'ClubListContainer.Description.Country.Portugal.p6',
    ],
  },
  IT: {
    title: 'ClubListContainer.Description.Country.Italy.Title',
    text: [
      'ClubListContainer.Description.Country.Italy.p1',
      'ClubListContainer.Description.Country.Italy.p2',
      'ClubListContainer.Description.Country.Italy.p3',
      'ClubListContainer.Description.Country.Italy.p4',
      'ClubListContainer.Description.Country.Italy.p5',
      'ClubListContainer.Description.Country.Italy.p6',
    ],
  },
  BE: {
    title: 'ClubListContainer.Description.Country.Belgium.Title',
    text: [
      'ClubListContainer.Description.Country.Belgium.p1',
      'ClubListContainer.Description.Country.Belgium.p2',
      'ClubListContainer.Description.Country.Belgium.p3',
      'ClubListContainer.Description.Country.Belgium.p4',
      'ClubListContainer.Description.Country.Belgium.p5',
      'ClubListContainer.Description.Country.Belgium.p6',
      'ClubListContainer.Description.Country.Belgium.p7',
    ],
  },
  SE: {
    title: 'ClubListContainer.Description.Country.Sweden.Title',
    text: [
      'ClubListContainer.Description.Country.Sweden.p1',
      'ClubListContainer.Description.Country.Sweden.p2',
      'ClubListContainer.Description.Country.Sweden.p3',
      'ClubListContainer.Description.Country.Sweden.p4',
      'ClubListContainer.Description.Country.Sweden.p5',
      'ClubListContainer.Description.Country.Sweden.p6',
    ],
  },
  DE: {
    title: 'ClubListContainer.Description.Country.Germany.Title',
    text: [
      'ClubListContainer.Description.Country.Germany.p1',
      'ClubListContainer.Description.Country.Germany.p2',
      'ClubListContainer.Description.Country.Germany.p3',
      'ClubListContainer.Description.Country.Germany.p4',
      'ClubListContainer.Description.Country.Germany.p5',
      'ClubListContainer.Description.Country.Germany.p6',
    ],
  },
};

export default countryDescriptions;
